<template>
    <div class="empty-state">
        <slot>
            <Icon class="empty-state__image" :icon="image"/>
            <p class="empty-state__text empty-state__title">{{ title }}</p>
            <p class="empty-state__text empty-state__description">{{ description }}</p>
        </slot>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
export default {
    name: 'EmptyState',
    components: {
        Icon
    },
    props: {
        image: String,
        title: String,
        description: String
    }
}
</script>

<style lang="scss" scoped>
.empty-state {
    text-align: center;
    &__image {

    }
    &__text {
        color: #718096;
        font-size: 16px;
        margin-bottom: 0;
    }
    &__title {
        font-family: 'Eina Bold';
        line-height: 24px;
        margin-top: 24px;
    }
    &__description {
        line-height: 24px;
    }
}
</style>